<section>
    <div class="py-20 px-6 mx-auto">
        <div class="text-center">
            <h1 class="mb-6 text-9xl font-extrabold text-gold">404</h1>
            <p class="mb-6 text-lg">Oops! The page you're looking for doesn't exist.</p>
            <p-button routerLink="/">BACK TO HOME</p-button>
        </div>   
    </div>
</section>
    